/**
 * @param {*} propName prop name without any locale suffix
 * @param {*} locale locale code
 * @returns propName with locale code appended in camel-case
 */
const getLocalePropName = (propName, locale) => {
  const [first, ...rest] = locale;
  const result = `${propName}${first.toUpperCase()}${rest.join('')}`;
  return result;
};

/**
 * Get correct prop from object based on current locale, returning English value as fallback
 * @param {object} obj
 * @param {string} propName prop name without any locale suffix
 * @param {*} locale Locale code used to construct locale-specific prop name and lookup
 * @returns Localized prop value
 */
export const getLocalizedPropValue = (obj, propName, locale) => {
  const localizedPropName = getLocalePropName(propName, locale);
  const localizedProp = obj[localizedPropName];

  return localizedProp || obj[`${propName}En`];
};
